import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "./subscription.css";
import Switch from "react-switch";
import { UtilityFunctions } from "../../../utils/UtilityFunctions";
import PaymentProcedure from "./PaymentProcedure";
import { api } from "../../../middleware/api";
import ValidationErrorToast from "../../../components/validationErrorToast";
import { userService } from "../../../_services/user.service";
import { cookieService } from "../../../_services/cookie.service";

const SubscriptionModalAccounts = (props: any) => {
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);
  const [isPlanSelected, setIsPlanSelected] = useState(null);
  const [isCardAdded, setIsCardAdded] = useState(false);
  const [productId, setProductId] = useState("prod_SGyNKbYSAVVBT7");
  const [subscriptionStep, setSubscriptionStep] = useState(1);
  const [couponCodeValue, setCouponCodeValue] = useState("");
  const [promoData, setPromoData] = useState<any>();
  const [showSpecialDiscount, setShowSpecialDiscount] = useState(false);
  const [specialDiscountAmount, setSpecialDiscountAmount] = useState<any>();
  const [specialDiscountSource, setSpecialDiscountSource] = useState<any>();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Determine whitelabel from hostname, not async config
  const hostname = window.location.hostname;
  const isWhitelabel = hostname !== 'localhost' && !hostname.includes('mploi.com');

  // Use whitelabel price text if available, otherwise fallback
  const [specificPrice, setSpecificPrice] = useState<any>(isWhitelabel ? '' : '$416 / month + GST');

  const getProductInfoForCode = () => {
    api.get(`subscription/code-detail/?code=${localStorage.getItem("referralCode")}`, {
      "product_id": localStorage.getItem("referralCode"),
    }).then((data) => {
      if (data) {
        setSpecificPrice(data.priceText);
        setProductId(data.productId);

        if (data.saving > 0) {
          setShowSpecialDiscount(true);
          setSpecialDiscountAmount(data.saving);
          setSpecialDiscountSource(data.code);
        }

        setSubscriptionStep(2);
      }
    })
      .catch((err) => {
        console.log("err", err);
      });
  }

  const handlePaymentOption = () => {
    handleCreateSubscription()
  }

  useEffect(() => {
    if (!isWhitelabel) {
      setProductId('prod_SGyNKbYSAVVBT7');
    }
    setSubscriptionStep(2);
  }, [props.subsModal])

  useEffect(() => {
    // Update price text when stripeConfig loads
    if (props.stripeConfig?.monthly_price_text) {
      setSpecificPrice(props.stripeConfig.monthly_price_text);
    } else if (props.stripeConfig?.monthly_price_id && !specificPrice) {
      setSpecificPrice('Monthly subscription');
    }
  }, [props.stripeConfig]);

  const handlePayment = () => {
    if (isPlanSelected != null) {
      setIsPaymentOpen(!isPaymentOpen);
    }
  };

  const handleCreateSubscription = () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    const hostname = window.location.hostname;
    const email = cookieService.getCookie('email') || localStorage.getItem('email');
    
    if (isWhitelabel && props.stripeConfig?.monthly_price_id) {
      console.log('Using whitelabel Stripe checkout', props.stripeConfig);
      // Use whitelabel Stripe checkout via mploi-ai backend
      const backendUrl = hostname === 'localhost' 
        ? 'http://localhost:5000' 
        : 'https://ai.mploi.com';
      
      fetch(`${backendUrl}/api/stripe/checkout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          whitelabel_domain: hostname,
          email: email,
          price_id: props.stripeConfig.monthly_price_id,
          success_url: `${window.location.protocol}//${hostname}/ar`,
          cancel_url: `${window.location.protocol}//${hostname}/ar`,
        })
      })
      .then(res => res.json())
      .then(data => {
        if (data.checkout_url) {
          window.location.href = data.checkout_url;
        } else {
          console.error('Stripe checkout error:', data);
          ValidationErrorToast(data.error || 'Something went wrong while making payment.', 'Payment error');
          setIsSubmitting(false);
        }
      })
      .catch((err) => {
        console.error('Stripe checkout fetch error:', err);
        ValidationErrorToast('Something went wrong while making payment.', 'Payment error');
        setIsSubmitting(false);
      });
    } else {
      // Fallback: original Django subscription endpoint
      api.post(`subscription/`, {
        "product_id": productId,
        "promo_code": couponCodeValue
      })
      .then((data) => {
        if (data.data.checkoutUrl && data.data.checkoutUrl !== undefined && data.data.checkoutUrl !== "") {
          window.location.href = data.data.checkoutUrl;
        } else {
          ValidationErrorToast('Something went wrong while making payment.', 'Payment error');
          setIsSubmitting(false);
        }
      })
      .catch(() => {
        ValidationErrorToast('Something went wrong while making payment.', 'Payment error');
        setIsSubmitting(false);
      });
    }
  }

  const handleDismiss = () => {
    props.setSubsModal(false);
    setCouponCodeValue("");
  };

  const handleLogout = () => {
    userService
      .logout()
      .then(() => {
        cookieService.removeAllCookies();
        window.location.href = "/signin";
      })
      .catch(() => {
        cookieService.removeAllCookies();
        window.location.href = "/signin";
      });
  };

  // Product name: neutral for whitelabel, branded for MPLOI
  const productName = isWhitelabel ? "Invoice Chaser" : "MPLOI Invoice Chaser";
  const productNameMonthly = isWhitelabel ? "Invoice Chaser Monthly" : "MPLOI Invoice Chaser Monthly";
  // Price text from Stripe already says "/ month" for MPLOI; only add it when it doesn't
  const priceSuffix = specificPrice && !/month/i.test(specificPrice) ? " / month" : "";
  const accent = isWhitelabel ? "#1a1a2e" : "#0065FF";
  const features = ["Follow up invoices with AI", "Personalise your agent", "Dedicated mobile number"];

  // subscription.css still targets .subs (it fades every <span>), so this view uses divs + inline styles
  const styles: { [key: string]: React.CSSProperties } = {
    page: {
      fontFamily: "'DM Sans', sans-serif",
      backgroundColor: "#F8F9FA",
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "24px 16px 48px",
      width: "100%",
      alignSelf: "stretch",
      textAlign: "left",
    },
    topBar: {
      width: "100%",
      maxWidth: "960px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "40px",
    },
    logoChip: {
      display: "inline-flex",
      alignItems: "center",
      background: "#0065FF",
      borderRadius: "10px",
      padding: "10px 18px",
    },
    topActions: { display: "flex", alignItems: "center", gap: "20px" },
    logout: {
      background: "none",
      border: "none",
      padding: 0,
      color: "#555555",
      fontSize: "14px",
      fontWeight: 500,
      cursor: "pointer",
    },
    close: { color: "#555555", fontSize: "22px", cursor: "pointer" },
    title: {
      fontFamily: "'Urbanist', sans-serif",
      fontWeight: 700,
      fontSize: "32px",
      lineHeight: 1.2,
      color: "#141414",
      textAlign: "center",
      margin: "0 0 8px",
    },
    subtitle: { fontSize: "16px", color: "#555555", textAlign: "center", margin: "0 0 32px" },
    card: {
      background: "#FFFFFF",
      borderRadius: "16px",
      padding: "32px",
      width: "100%",
      maxWidth: "480px",
      border: "1px solid #E0E0E0",
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.05)",
    },
    planChip: {
      display: "inline-block",
      background: isWhitelabel ? "#EEEEF2" : "#E6F0FF",
      color: accent,
      borderRadius: "999px",
      padding: "6px 14px",
      fontSize: "13px",
      fontWeight: 700,
      marginBottom: "16px",
    },
    price: {
      fontFamily: "'Urbanist', sans-serif",
      fontWeight: 700,
      fontSize: "36px",
      lineHeight: 1.15,
      color: "#141414",
      marginBottom: "24px",
    },
    featureList: { listStyle: "none", padding: 0, margin: "0 0 24px" },
    feature: { display: "flex", alignItems: "center", gap: "10px", fontSize: "15px", color: "#242424", marginBottom: "12px" },
    tick: { color: accent, fontSize: "16px", width: "16px" },
    divider: { border: "none", borderTop: "1px solid #E0E0E0", margin: "0 0 20px" },
    row: { display: "flex", justifyContent: "space-between", gap: "16px", fontSize: "14px", color: "#555555", marginBottom: "10px" },
    rowTotal: { display: "flex", justifyContent: "space-between", gap: "16px", fontSize: "16px", fontWeight: 700, color: "#141414", margin: "4px 0 24px" },
    discount: { color: "#1E8E3E", textAlign: "right" },
    button: {
      background: accent,
      borderRadius: "8px",
      border: "none",
      boxShadow: isWhitelabel ? "none" : "0px 10px 20px -10px rgba(0, 101, 255, 0.4)",
      padding: "16px",
      fontFamily: "'DM Sans', sans-serif",
      fontWeight: 700,
      fontSize: "16px",
      color: "#FFFFFF",
      cursor: "pointer",
      width: "100%",
    },
    buttonBusy: { opacity: 0.6, pointerEvents: "none" },
    secure: { fontSize: "13px", color: "#777777", textAlign: "center", marginTop: "12px" },
  };

  return (
    <>
      <Modal show={props.subsModal} fullscreen={true} className="subs">
          {subscriptionStep === 2 ?
            <div style={styles.page}>
              <div style={styles.topBar}>
                <div>
                  {!isWhitelabel && (
                    <div style={styles.logoChip}>
                      <img alt="MPLOI" style={{ height: "24px" }} src={UtilityFunctions.getImageURL() + "logo_White.svg"} />
                    </div>
                  )}
                </div>
                <div style={styles.topActions}>
                  <button type="button" style={styles.logout} onClick={handleLogout}>Log out</button>
                  <i className="fa fa-times" style={styles.close} aria-label="Close" onClick={handleDismiss}></i>
                </div>
              </div>

              <h1 style={styles.title}>{productName} Subscription</h1>
              <p style={styles.subtitle}>Start collecting cash from outstanding invoices today.</p>

              <div style={styles.card}>
                <div style={styles.planChip}>{productName}</div>
                <div style={styles.price}>{specificPrice ? `${specificPrice}${priceSuffix}` : "Monthly subscription"}</div>

                <ul style={styles.featureList}>
                  {features.map((f) => (
                    <li key={f} style={styles.feature}>
                      <i className="fa fa-check" style={styles.tick} aria-hidden="true"></i>
                      {f}
                    </li>
                  ))}
                </ul>

                <hr style={styles.divider} />
                <div style={styles.row}>
                  <div>{productNameMonthly}</div>
                  <div>{specificPrice ? `${specificPrice}${priceSuffix}` : 'Monthly subscription'}</div>
                </div>
                {showSpecialDiscount && specialDiscountAmount && specialDiscountSource && (
                  <div style={styles.row}>
                    <div>Special discount</div>
                    <div style={styles.discount}>-${specialDiscountAmount} courtesy of {specialDiscountSource}</div>
                  </div>
                )}
                {promoData && (
                  <div style={styles.row}>
                    <div>Promo</div>
                    <div style={styles.discount}>You are saving ${promoData?.price?.discountAmount}</div>
                  </div>
                )}
                <div style={styles.rowTotal}>
                  <div>Pay</div>
                  <div>{specificPrice ? `${specificPrice}${priceSuffix}` : 'See checkout'}</div>
                </div>

                <button
                  type="button"
                  style={{ ...styles.button, ...(isSubmitting ? styles.buttonBusy : {}) }}
                  onClick={() => handlePaymentOption()}
                >
                  {isSubmitting ? 'Processing...' : `Pay ${specificPrice ? `${specificPrice}${priceSuffix}` : ''}`}
                </button>
                <div style={styles.secure}>Secure checkout with Stripe.</div>
              </div>
            </div>
            : ""}
        {isPaymentOpen ?
          <div style={{ width: "100vw", height: "100%" }} className=" container-fluid position-absolute outer_container" onClick={() => handlePayment()}>
            <div className=" d-flex align-items-center justify-content-center" style={{ width: "100vw", height: "100vh" }}>
              <PaymentProcedure
                isCardAdded={isCardAdded}
                productId={productId}
                couponCodeValue={couponCodeValue}
              />
            </div>
          </div>
          :
          null}
      </Modal >
    </>
  );
};

export default SubscriptionModalAccounts;
